import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig'
import { StoreListResp } from 'domain/payload/response/store/StoreListResp';
import { StoreDetailResp } from 'domain/payload/response/store/StoreDetailResp';
import { StoreCreateReq } from 'domain/payload/request/store/StoreCreateReq';
import { StoreUpdateReq } from 'domain/payload/request/store/StoreUpdateReq';

const StoreService = () => {
  const storeList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<StoreListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/store/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const storeDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<StoreDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/store/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const storeGenerateCode = async (
    token: string
  ): Promise<BaseResponse<string>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/store/random-code`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const storeExportToCsv = async (token: string): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/report-engine/download?reportCode=PLACE_CSV_EXPORT&extension=csv`, {}, { 
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message || error;
    }
  };

  const storeCreate = async (
    token: string,
    request: StoreCreateReq
  ): Promise<BaseResponse<StoreDetailResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/store/create`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const storeUpdate = async (
    token: string,
    request: StoreUpdateReq
  ): Promise<BaseResponse<StoreDetailResp>> => {
    try {
      console.log("Final payload:", JSON.stringify(request, null, 2));
      const response = await axiosInstance.put(`/v1/legacy/cms/store/update`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const storeDelete = async (
    token: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(`/v1/legacy/cms/store/delete`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  return { storeList, storeDetail, storeGenerateCode, storeExportToCsv, storeCreate, storeUpdate, storeDelete };
};

export default StoreService;